<template>
  <div id="adminContainer">
    <div class="inner">
      <div
        style="
          width: 6px;
          height: 20px;
          background: #464775;
          float: left;
          margin-right: 10px;
        "
      ></div>
      <div style="float: left; position: relative; top: -4px">
        <h3 class="pr-3" style="font-weight: 600">회의실 관리</h3>
      </div>
      <div
        style="
          clear: both;
          width: 99%;
          height: 2.5px;
          background-color: #e9e9e9;
        "
      ></div>

      <!-- 사업장 추가 -->
      <modal name="addBuilding" :width="100" :height="200">
        <div class="layer_popWrap" style="display: block">
          <div class="bg"></div>
          <div
            class="pop-inner"
            style="top: 30%; width: 500px; margin-left: -150px"
          >
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">
                {{ editBuilding.buildingTitile }}<span class="titline"></span>
              </h1>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <span class="input_txt ico01"
                  ><input
                    type="text"
                    placeholder="빌딩 이름"
                    v-model="editBuilding.editBuildingName"
                /></span>
                <!-- <div class="input_w50">
                  <span class="input_txt fl ico03" style="margin-right:3%"><input type="text" id="" name=""
                      value="고층 "></span>
                  <span class="input_txt fl ico04"><input type="text" id="" name="" value="저층 "></span>
                </div>
                <span class="input_txt ico02"><input type="text" id="" name="" value="정렬"></span> -->
              </div>

              <div class="btn_crud" style="margin-top: 30px">
                <a
                  class="btn_com small"
                  style="width: 100px"
                  @click="addBuilding()"
                  >추가</a
                >
                <a
                  class="btn_line small"
                  style="width: 100px"
                  @click="closeAddBuildingPopup()"
                  >취소</a
                >
              </div>
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>

      <!-- 회의실 추가 -->
      <modal name="addMeetingRoom" :width="600" :height="350">
        <div class="layer_popWrap" style="display: inline-block">
          <div class="bg"></div>
          <div class="inner" style="width: 500px; padding: 0; top: 25%">
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">
                {{ editMeetingRoom.meetingRoomTitile
                }}<span class="titline"></span>
              </h1>
              <a @click="closeAddMeetingRoomPopup()" class="pop_close">x</a>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <span class="input_txt ico08">
                  <input
                    style="color: #000"
                    type="text"
                    placeholder="회의실명"
                    v-model="editMeetingRoom.editRoomName"
                  />
                </span>

                <span class="input_txt ico08"
                  ><input
                    style="color: #000"
                    type="number"
                    placeholder="수용인원"
                    v-model="editMeetingRoom.editCapacity"
                /></span>

                <!-- <span class="input_txt ico02"><input type="text" id="" name="" value="정렬"></span> -->
              </div>
              <div class="btnArea" style="justify-content: center">
                <button
                  type="submit"
                  class="btnPrimary"
                  @click="addMeetingRoom()"
                >
                  저장
                </button>
                <button
                  type="submit"
                  class="btn type3 reset"
                  @click="closeAddMeetingRoomPopup()"
                >
                  취소
                </button>
              </div>

              <!-- <div class="btn_crud" style="margin-top: 30px">
                <a class="btnPrimary" @click="addMeetingRoom()">추가</a>
                <a class="btn_line small" @click="closeAddMeetingRoomPopup()"
                  >취소</a
                >
              </div> -->
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>

      <!-- 회사 삭제 POPUP -->
      <modal name="deleteCorp" :width="500" :height="250">
        <div class="layer_popWrap" style="display: inline-block">
          <div class="bg"></div>
          <div class="inner" style="width: 500px; padding: 0">
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">대그룹 삭제<span class="titline"></span></h1>
              <a class="pop_close" @click="closeDeleteCorpPopup()">x</a>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <p class="txt">선택하신 대그룹을 삭제 하시겠습니까?</p>
              </div>

              <div class="btn_crud" style="margin-top: 30px">
                <a
                  class="btn_com small"
                  style="width: 80px"
                  @click="deleteCorp()"
                  >삭제</a
                >
                <a
                  class="btn_line small"
                  style="width: 80px"
                  @click="closeDeleteCorpPopup()"
                  >취소</a
                >
              </div>
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>

      <!-- 회의실 삭제 POPUP -->
      <modal name="deleteMeetingRoom" :width="500" :height="250">
        <div class="layer_popWrap" style="display: inline-block">
          <div class="bg"></div>
          <div class="inner" style="width: 500px; padding: 0">
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">회의실 삭제<span class="titline"></span></h1>
              <a class="pop_close" @click="closeDeleteMeetingRoomPopup()">x</a>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <p class="txt">선택하신 회의실을 삭제 하시겠습니까?</p>
              </div>

              <div class="btn_crud" style="margin-top: 30px">
                <a class="btn_com small" @click="deleteMeetingRoom()">삭제</a>
                <a class="btn_line small" @click="closeDeleteMeetingRoomPopup()"
                  >취소</a
                >
              </div>
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>

      <!-- 사업장 삭제 POPUP -->
      <modal name="deleteBuilding" :width="500" :height="250">
        <div class="layer_popWrap" style="display: inline-block">
          <div class="bg"></div>
          <div class="inner" style="width: 500px; padding: 0">
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">건물 삭제<span class="titline"></span></h1>
              <a class="pop_close" @click="closeDeleteBuildingPopup()">x</a>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <p class="txt">선택하신 빌딩을 삭제 하시겠습니까?</p>
              </div>

              <div class="btn_crud" style="margin-top: 30px">
                <a class="btn_com small" @click="deleteBuilding()">삭제</a>
                <a class="btn_line small" @click="closeDeleteBuildingPopup()"
                  >취소</a
                >
              </div>
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>
      <!--scrollWrap -->
      <div class="scrollWrap" style="overflow-y: auto">
        <!-- max-height: 70vh; -->
        <v-layout row>
          <v-flex lg4 md4 sm12 xs12>
            <v-card>
              <v-toolbar
                card
                dense
                color="transparent"
                class="pa-2 tertiary lighten-1"
                dark
                style="height: 45px"
              >
                <v-toolbar-title style="height: 45px">
                  <h5>회사 및 본부 선택</h5>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-treeview
                  class="organization-list"
                  activatable
                  :items="companyList"
                  item-key="name"
                >
                  <template slot="label" slot-scope="{ item }">
                    <div
                      class="organization-list-item"
                      @click="openTeamMember(item)"
                    >
                      {{ item.name }}
                    </div>
                  </template>
                </v-treeview>
                <!-- <v-treeview 
                class="organization-list"
                selectable
                show-checkbox
                :items="testList"  
                item-key="name">
                <template slot="label" slot-scope="{ item }">
                  <div class="organization-list-item" @click="openTeamMember(item)">{{ item.name }}</div>
                </template>
              </v-treeview> -->
                <div class="btn_crud">
                  <a
                    class="btn_com small"
                    @click="openCorpCreateDialog()"
                    v-show="addCorpBtn === true"
                    >대그룹 추가</a
                  >
                  <a
                    class="btn_line small"
                    @click="openDeleteBuildingPopup()"
                    v-show="deleteBuildingBtn === true"
                    >건물 삭제</a
                  >
                  <a
                    class="btn_com small"
                    style="background: #ffa000"
                    @click="openBuildingCreateDialog()"
                    v-show="addBuildingBtn === true"
                    >건물 추가</a
                  >
                  <a
                    class="btn_com small"
                    v-show="modifyCorpBtn === true"
                    @click="openEditCorpPopup()"
                    >대그룹 수정</a
                  >
                  <a
                    class="btn_line small"
                    v-show="deleteCorpBtn === true"
                    @click="openDeleteCorpPopup()"
                    >대그룹 삭제</a
                  >
                  <a
                    class="btn_com small"
                    v-show="modifyBuildingBtn === true"
                    @click="openEditBuildingPopup()"
                    >건물 수정</a
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- RIGHT -->
          <v-flex
            lg8
            md8
            sm12
            xs12
            style="margin-left: 20px; max-height: 80vh; overflow-y: auto"
          >
            <v-card>
              <v-toolbar
                card
                dense
                color="transparent"
                class="pa-2 tertiary darken-1"
                dark
                style="height: 45px"
              >
                <v-toolbar-title style="height: 45px">
                  <h5>
                    {{
                      selectedBuilding ? selectedBuilding.name : '회의실 선택'
                    }}
                  </h5>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div
                  v-if="selectedBuilding._id !== null"
                  @click="openRoomCreateDialog"
                  style="margin-top: -5px; height: 35px; cursor: pointer"
                >
                  <v-icon small style="position: relative; top: -5px"
                    >add</v-icon
                  >&nbsp;{{ $t('page.meetingroom-mgr.meeting-room.add') }}
                </div>
                <!-- <v-btn icon>
                <v-icon>more_vert</v-icon>
              </v-btn> -->
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <template>
                  <v-data-table
                    :headers="getHeaders()"
                    :items="rooms"
                    :rows-per-page-items="pageItem"
                    :pagination.sync="pagination"
                    class="elevation-0 table-striped"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">{{ props.item.name }}</td>
                      <!-- <td class="text-xs-center">
                      <v-icon label small :color="props.item.type == 'video' ? 'pink' : 'green'" text-color="white" >
                        {{ props.item.type == 'video' ? "mdi-desktop-mac" : "mdi-door-open" }}
                      </v-icon>&nbsp;{{ props.item.type == 'video' ? $t('page.meetingroom-mgr.meeting-room.type-video') : $t('page.meetingroom-mgr.meeting-room.type-room') }}
                    </td> -->
                      <td class="text-xs-center">
                        {{
                          props.item.capacity !== null
                            ? `
                          ${props.item.capacity} 
                          ${$t('page.meetingroom-mgr.people-unit')}`
                            : `-`
                        }}
                      </td>
                      <td class="text-xs-center">
                        <a
                          class="icocom modi_ico"
                          @click="openEditMeetingRoomPopup(props.item)"
                        ></a>
                        <!-- <v-icon color="success" @click="editItem(props.item)">edit</v-icon> -->
                      </td>
                      <td class="text-xs-center">
                        <a
                          class="icocom delete_ico"
                          @click="openDeleteMeetingRoomPopup(props.item)"
                        ></a>
                        <!-- <v-icon color="error" @click="deleteItem(props.item)">delete</v-icon> -->
                      </td>
                    </template>
                  </v-data-table>
                </template>
                <v-divider></v-divider>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <!--sc_left 좌측 -->
        <div class="sc_left fl">
          <!--searchbox -->
          <!-- <div class="searchbox02" style="margin-right:15px">
            <div class="search_top inblk wid437">
                <label for="" class="blind"></label>
                <input type="text" class="search_input wid437" placeholder="검색명 입력" v-model="searchCorpName">
                <button class="search_btn" @click="searchCorp()">
                    <span class="ir">검색</span>
                </button>
            </div>
          </div> -->
          <!--//searchbox -->

          <!--scroll_ctn -->
          <!-- <div class="scroll_ctn">
          <div class="scroll_ctn_inner mCustomScrollbar">
            <v-treeview 
              class="organization-list"
              activatable
              :items="companyList"  
              item-key="name">
              <template slot="label" slot-scope="{ item }">
                <div class="organization-list-item" @click="openTeamMember(item)">{{ item.name }}</div>
              </template>
            </v-treeview>
          </div>

          <div class="btn_crud">
            <a class="btn_com small" 
              @click="openCorpCreateDialog()" 
              v-show="addCorpBtn === true">대그룹 추가</a>
            <a class="btn_line small" @click="openDeleteBuildingPopup()" v-show="deleteBuildingBtn === true">건물 삭제</a>
            <a class="btn_com small" style="background: #ffa000" 
              @click="openBuildingCreateDialog()"
              v-show="addBuildingBtn === true">건물 추가</a>
            <a class="btn_com small" v-show="modifyCorpBtn === true" @click="openEditCorpPopup()">대그룹 수정</a>
            <a class="btn_line small" v-show="deleteCorpBtn === true" @click="openDeleteCorpPopup()">대그룹 삭제</a>
            <a class="btn_com small" v-show="modifyBuildingBtn === true" @click="openEditBuildingPopup()">건물 수정</a>
          </div>
        </div> -->

          <!--//scroll_ctn -->
        </div>
        <!--//sc_left -->

        <!--//sc_right -->
      </div>
      <!--//scrollWrap -->
    </div>
    <corp-create-dialog
      :dialog="corpCreateDialog.dialog"
      :editCorp="editCorp"
      :closeDialog="closeCorpCreateDialog"
    />
    <building-create-dialog
      :dialog="buildingCreateDialog.dialog"
      :companyId="this.companyId"
      :closeDialog="closeBuildingCreateDialog"
    />
    <room-create-dialog
      :dialog="roomCreateDialog.dialog"
      :companyId="this.companyId"
      :selectedBuilding="this.selectedBuilding"
      :closeDialog="closeRoomCreateDialog"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Util from '@/util';
import VModal from 'vue-js-modal';
import Vuetify from 'vuetify';
import CorpCreateDialog from '@/components/admin/popup/CorpCreateDialog';
import BuildingCreateDialog from '@/components/admin/popup/BuildingCreateDialog';
import RoomCreateDialog from '@/components/admin/popup/RoomCreateDialog';
Vue.use(VModal);
export default {
  components: {
    VModal,
    CorpCreateDialog,
    BuildingCreateDialog,
    RoomCreateDialog,
  },
  data: () => ({
    pageItem: [5, 10, 15, { text: 'All', value: -1 }],
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    companyList: [],
    testList: [], //테스트용
    testActive: [],
    companyId: null,
    buildingName: null,
    sort: null,
    searchCorpName: null,
    addCorpBtn: false,
    modifyCorpBtn: false,
    deleteCorpBtn: false,
    addBuildingBtn: false,
    modifyBuildingBtn: false,
    deleteBuildingBtn: false,
    clickedCorp: false,
    selectedCorp: null,
    selectedBuilding: {
      _id: null,
      name: null,
    },
    selectedRoom: null,
    showMeetingRoomList: false,
    currentClickCorp: null,
    rooms: [],
    corpCreateDialog: {
      dialog: false,
    },
    buildingCreateDialog: {
      dialog: false,
    },
    roomCreateDialog: {
      dialog: false,
    },
    defaultCorp: {
       _id: null,
      corpTitile: '회사 추가',
      corpId: null,
      type: 'add',
      editCorpName: null,
    },
    defaultBuilding: {
      buildingTitile: '빌딩 추가',
      corpId: null,
      buildingId: null,
      editBuildingName: null,
    },
    defaultMeetingRoom: {
      meetingRoomTitile: '회의실 추가',
      roomId: null,
      editRoomName: null,
      editCapacity: null,
    },
    editCorp: {
      _id: null,
      corpTitile: '회사 추가',
      corpId: null,
      type: 'add',
      editCorpName: null,
    },
    editBuilding: {
      buildingTitile: '빌딩 추가',
      corpId: null,
      buildingId: null,
      editBuildingName: null,
    },
    editMeetingRoom: {
      meetingRoomTitile: '회의실 추가',
      roomId: null,
      editRoomName: null,
      editCapacity: 0,
    },
  }),
  mounted() {
    // console.log(`mounted`);
  },
  async activated() {
    if (!Util.hasSession(this)) return;
    this.init();
  },
  methods: {
    init() {
      this.getCorp();
    },
    getHeaders() {
      return [
        {
          text: this.$t('page.meetingroom-mgr.meeting-room.name'),
          value: 'name',
          align: 'center',
          sortable: false,
          class: 'header-text',
        },
        {
          text: this.$t('page.meetingroom-mgr.meeting-room.capacity'),
          value: 'capacity',
          align: 'center',
          width: 150,
          sortable: false,
          class: 'header-text',
        },
        {
          text: this.$t('page.meetingroom-mgr.meeting-room.modify'),
          align: 'center',
          width: 150,
          sortable: false,
          class: 'header-text',
        },
        {
          text: this.$t('page.meetingroom-mgr.meeting-room.edit-delete'),
          align: 'center',
          width: 150,
          sortable: false,
          class: 'header-text',
        },
      ];
    },
    openCorpCreateDialog() {
      this.corpCreateDialog.dialog = true;
    },
    closeCorpCreateDialog() {
      this.corpCreateDialog.dialog = false;
      this.editCorp = Object.assign({}, this.defaultCorp);
      this.getCorp();
    },
    openBuildingCreateDialog() {
      this.buildingCreateDialog.dialog = true;
    },
    closeBuildingCreateDialog() {
      this.buildingCreateDialog.dialog = false;
      this.getCorp();
    },
    openRoomCreateDialog() {
      this.roomCreateDialog.dialog = true;
    },
    closeRoomCreateDialog() {
      this.roomCreateDialog.dialog = false;
      this.getRooms(this.selectedBuilding._id);
    },
    openAddMeetingRoomPopup() {
      /* 빌딩 추가 Modal */
      this.$modal.show('addMeetingRoom');
    },
    openEditCorpPopup() {
      /* 회사 수정 Modal */
      this.corpCreateDialog.dialog = true;
      this.editCorp._id = this.selectedCorp._id
      this.editCorp.corpTitile = '대그룹 수정';
      this.editCorp.type = 'edit';
      this.editCorp.editCorpName = this.selectedCorp.name;
    },
    openEditBuildingPopup() {
      /* 회사 수정 Modal */
      this.$modal.show('addBuilding');

      this.editBuilding.buildingTitile = '빌딩 수정';
      this.editBuilding.editBuildingName = this.selectedBuilding.name;
      this.editBuilding.buildingId = this.selectedBuilding._id;
    },
    openEditMeetingRoomPopup(roomInfo) {
      /* 회의실 수정 Modal */
      console.log(roomInfo);

      this.$modal.show('addMeetingRoom');
      this.selectedRoom = roomInfo;
      this.editMeetingRoom.meetingRoomTitile = '회의실 수정';
      this.editMeetingRoom.roomId = roomInfo._id;
      this.editMeetingRoom.editRoomName = roomInfo.room;
      this.editMeetingRoom.editCapacity = roomInfo.capacity;
    },
    closeAddCorpPopup() {
      this.clearModalValue();
      this.$modal.hide('addCorp');
    },
    closeAddBuildingPopup() {
      this.$modal.hide('addBuilding');
    },
    closeAddMeetingRoomPopup() {
      this.$modal.hide('addMeetingRoom');
    },
    openDeleteCorpPopup() {
      this.$modal.show('deleteCorp');
    },
    openDeleteBuildingPopup() {
      this.$modal.show('deleteBuilding');
    },
    openDeleteMeetingRoomPopup(roomInfo) {
      this.$modal.show('deleteMeetingRoom');

      this.selectedRoom = roomInfo;
      this.editMeetingRoom.roomId = roomInfo._id;
    },
    closeDeleteCorpPopup() {
      this.$modal.hide('deleteCorp');
    },
    closeDeleteBuildingPopup() {
      this.$modal.hide('deleteBuilding');
    },
    closeDeleteMeetingRoomPopup() {
      this.$modal.hide('deleteMeetingRoom');
    },
    async addCorp() {
      /* 회사추가팝업 > 추가 */
      let corpName = this.editCorp.editCorpName;

      let params = { corpName: corpName };

      await this.$http
        .post('/api/v1/company/addCorp', params)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('회사 정보가 적용되었습니다.'),
              'primary'
            );
            this.clearModalValue();
            this.$modal.hide('addCorp');
            this.companyList = [];
            this.getCorp();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async addBuilding() {
      /* 사업장추가팝업 > 추가 */
      let buildingName = this.editBuilding.editBuildingName;
      let buildingId = this.editBuilding.buildingId;
      let companyId = this.companyId;

      let params = {
        buildingId: buildingId,
        buildingName: buildingName,
        companyId: companyId,
      };

      console.log(params);
      await this.$http
        .post('/api/v1/building/addBuilding', params)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('빌딩 정보가 적용되었습니다.'),
              'primary'
            );
            this.clearModalValue();
            this.$modal.hide('addBuilding');
            this.companyList = [];
            this.getCorp();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async addMeetingRoom() {
      console.log('addMeetingRoom');
      /* 회의실추가 */
      let companyId = this.companyId;
      let bdId = this.selectedBuilding._id;
      let roomId = this.editMeetingRoom.roomId;
      let roomName = this.editMeetingRoom.editRoomName;
      let capacity = this.editMeetingRoom.editCapacity;
      let params = {
        companyId: companyId,
        buildingId: bdId,
        roomId: roomId,
        roomName: roomName,
        capacity: capacity,
      };

      await this.$http
        .post('/api/v1/rooms/addRoom', params)
        .then((response) => {
          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('회의실 정보가 적용되었습니다.'),
              'primary'
            );
            this.clearModalValue();
            this.$modal.hide('addMeetingRoom');
            this.getRooms(bdId);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteCorp() {
      /* 회사 삭제 Function */
      let companyId = this.companyId;

      let params = { companyId: companyId };
      await this.$http
        .post('/api/v1/company/deleteCorp', params)
        .then((response) => {
          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('회사 정보가 적용되었습니다.'),
              'primary'
            );
            this.clearModalValue();
            this.$modal.hide('deleteCorp');
            this.companyList = [];
            this.getCorp();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteBuilding() {
      /* 사업장 삭제 Function */
      let buildingId = this.selectedBuilding._id;
      let params = { buildingId: buildingId };

      await this.$http
        .post('/api/v1/building/deleteBuilding', params)
        .then((response) => {
          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('빌딩 정보가 적용되었습니다.'),
              'primary'
            );
            this.clearModalValue();
            this.$modal.hide('deleteBuilding');
            this.companyList = [];
            this.getCorp();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteMeetingRoom() {
      /* 회의실 삭제 Function */
      let bdId = this.selectedBuilding._id;
      let roomId = this.editMeetingRoom.roomId;
      let params = { roomId: roomId };

      await this.$http
        .post('/api/v1/rooms/deleteRoom', params)
        .then((response) => {
          if (response.data.ret === false) {
            if (response.data.msg) {
              alert(response.data.msg);
            }
            return;
          }
          console.log(response);
          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('회의실 정보가 적용되었습니다.'),
              'primary'
            );
            this.clearModalValue();
            this.$modal.hide('deleteMeetingRoom');
            this.getRooms(bdId);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clearModalValue() {
      this.editCorp = Object.assign({}, this.defaultCorp);
      this.editBuilding = Object.assign({}, this.defaultBuilding);
      this.editMeetingRoom = Object.assign({}, this.defaultMeetingRoom);
    },
    searchCorp() {
      /* 회의실 관리 > 검색 */
      let searchCorpName = this.searchCorpName;
      alert('업데이트 예정');
    },
    async getCorp() {
      await this.$http
        .get(`/api/v1/company`)
        .then((response) => {
          this.companyList = [];
          let rst = response.data;
          if (rst !== 'noData') {
            for (let i = 0; i < rst.length; i++) {
              this.companyList.push(rst[i]);
            }
          }

          // 테스트
          this.testList = this.companyList;

          this.clearBtn();
          this.addCorpBtn = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getBuilding(buildingInfo) {
      let bdId = buildingInfo;

      await this.$http
        .get(`/api/v1/building`)
        .then((response) => {
          let rst = response.data;
          if (rst) {
            this.addCorpBtn = true;
            this.showConferenceRooms(rst[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getRooms(buildingInfo) {
      let bdId = buildingInfo;
      let params = { bdId: bdId };
      await this.$http
        .get('/api/v1/rooms/getRooms', { params: params })
        .then((response) => {
          let rst = response.data;
          if (rst) {
            this.rooms = rst;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async showConferenceRooms(company) {
      this.companyId = company._id;
      let params = {
        companyId: company._id,
      };
      await this.$http
        .get('/api/v1/rooms/treeAll', { params: params })
        .then((response) => {
          if (response) {
            let data = response.data;
            console.log(data);
            this.group.push(data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openTeamMember(team) {
      console.log(`openTeamMember`, team);
      /* 회의실 클릭 */
      this.clearBtn();
      // if (team.hasOwnProperty('companyId') === true && team.hasOwnProperty('buildingId') === true && team.hasOwnProperty('room') === true) {
      //   this.clickedRoom = team;
      // } else
      if (team.hasOwnProperty('companyId')) {
        this.selectedBuilding = team;
        this.currentClickCorp = null;

        this.modifyBuildingBtn = true;
        this.deleteBuildingBtn = true;
        this.showMeetingRoomList = true;

        this.getRooms(team._id);
        this.clickedCorp = false;
        this.addCorpBtn = false;
        console.log('빌딩');
      }
       else {
        if (team.name !== this.currentClickCorp) {
          this.selectedCorp = team;
          this.clickedCorp = true;

          this.addCorpBtn = false;
          this.modifyCorpBtn = true;
          this.deleteCorpBtn = true;

          this.addBuildingBtn = true;
          this.currentClickCorp = team.name;
        } else {
          this.clickedCorp = false;
          this.addCorpBtn = true;
          console.log('같음');
          this.currentClickCorp = null;
        }
        this.companyId = team._id;
      }
    },
    clearBtn() {
      this.showMeetingRoomList = false;

      this.addCorpBtn = false;
      this.modifyCorpBtn = false;
      this.deleteCorpBtn = false;

      this.addBuildingBtn = false;
      this.modifyBuildingBtn = false;
      this.deleteBuildingBtn = false;
    },
  },
};
</script>
<style scoped>
#adminContainer .v-toolbar {
  background-color: #6264a7 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/sections/ManageMeetingRoom.vue